<template lang="pug">
    v-container(ref="cashMovArea")
        v-layout(row wrap)
            v-flex(xs12 md6 pa-2)
                v-text-field(style="min-height: 100px" label="Cajero Actor" readonly v-model="cashier")
            v-flex(xs12 md6 pa-2)
                v-text-field(style="min-height: 100px" label="Fecha" readonly v-model="date")
        v-layout(row wrap)
            v-flex(xs12 md6 pa-2)
                v-text-field(prefix="$" validate-on-blur v-model="cash"
                    ref="amountInput"
                    :label="typeMovement != 'Apertura de caja' ? 'Monto' : 'Monto inicial' "
                    :mask="mixCurrencyMask(cash, 12)"
                    :rules="[rules.required, rules.rounded]"
                    @keydown.enter="mixHandleFocus(focusOrder, ()=>{})"
                    @input="setCashAmount(cash)")
            v-flex(xs12 md6 pa-2 v-if="movement != 'apertura'")
                v-autocomplete(:items="itemsTypeMovement"
                        ref="typeSelect"
                        item-text="type"
                        item-value="id"
                        label="Seleccionar motivo movimiento"
                        v-model="movTypeSelected"
                        @input="setMovementType(movTypeSelected)"
                        @change="mixHandleFocus(focusOrder, ()=>{})"
                        :rules="[rules.requiredSelect]" validate-on-blur)
            template(v-else-if="this.integrationCountersAreEnabled")
                v-flex.xs12.md6
                v-flex.xs12.md6.pa-2
                        v-text-field(
                            ref="ticketInput"
                            outline
                            @keydown.enter="mixHandleFocus(focusOrder, ()=>{})"
                            label="N°Boleta Inicial"
                            v-model="initialTicketNumber"
                            :rules="[rules.required]"
                            mask="############"
                        )
                v-flex.xs12.md6.pa-2
                        v-text-field(
                            ref="finalTicketInput"
                            outline
                            @keydown.enter="mixHandleFocus(focusOrder, ()=>{})"
                            label="N°Boleta Final"
                            v-model="finalTicketNumber"
                            :rules="[rules.required]"
                            mask="############"
                        )
                v-flex.xs12.md6.pa-2
                        v-text-field(
                            ref="invoiceInput"
                            outline
                            @keydown.enter="mixHandleFocus(focusOrder, ()=>{})"
                            label="N°Factura Inicial"
                            v-model="initialInvoiceNumber"
                            :rules="[rules.required]"
                            mask="############"
                        )
                v-flex.xs12.md6.pa-2
                        v-text-field(
                            ref="finalInvoiceInput"
                            outline
                            @keydown.enter="mixHandleFocus(focusOrder, ()=>{})"
                            label="N°Factura Final"
                            v-model="finalInvoiceNumber"
                            :rules="[rules.required]"
                            mask="############"
                        )
                v-flex.xs12.md6.pa-2
                        v-text-field(
                            ref="creditNoteInput"
                            outline
                            @keydown.enter="mixHandleFocus(focusOrder, ()=>{})"
                            label="N°Nota de Crédito Inicial"
                            v-model="initialCreditNoteNumber"
                            :rules="[rules.required]"
                            mask="############"
                        )
                v-flex.xs12.md6.pa-2
                        v-text-field(
                            ref="finalCreditNoteInput"
                            outline
                            @keydown.enter="mixHandleFocus(focusOrder, ()=>{})"
                            label="N°Nota de Crédito final"
                            v-model="finalCreditNoteNumber"
                            mask="############"
                        )
                v-flex.xs12.md6.pa-2
                        v-text-field(
                            ref="transbankInput"
                            outline
                            @keydown.enter="mixHandleFocus(focusOrder, ()=>{})"
                            label="N°Comprobante de Transbank inicial"
                            v-model="initialTransbankNumber"
                            :rules="[rules.required]"
                            @blur="handleTbkNumber()"
                            mask="######"
                        )
        v-layout(row wrap)
            v-flex(xs12 md6 pa-2)
                h3 Comentario
                v-textarea(ref="commentInput" solo label="Escriba aquí" v-model="comment" auto-grow outline
                    @input="setComment(comment)"
                    )
        v-layout
            v-spacer
            v-flex(xs12 md6 class="text-xs-right" align-end)
                supervisor-unique-key-modal(
                :available='checkValues'
                :title='typeMovement' 
                :showModal='showModal'
                @check-key="authorizeCashMov"
                confirmMessage="(F8) Confirmar"
                @clearform="clearFormCashMovement")
                    modal-cash-movement-content
</template>

<script>
import ModalCashMovement from '@/components/CashMovement/ModalCashMovementContent'
import SupervisorUniqueKeyModal from '@/components/SupervisorUniqueKey/Modal'
import CurrencyUtils from '@/mixins/CurrencyUtils'
import DateUtils from '@/mixins/DateUtils'
import { mapState, mapActions, mapGetters } from 'vuex'
import {
    sendIntegrationTicketNumber,
    sendIntegrationInvoiceTicketNumber,
    sendIntegrationCreditNoteNumber,
    sendTransbankNumber,
    getAllCounters,
} from '../../services/API/Integration'
import IncomeTypeModel from '../../models/POS/PosCashMovementIngressType'
import EgressTypeModel from '../../models/POS/PosCashMovementEgressType'
import JSUtils from '@/mixins/reusable_mixins/JSUtils'
export default {
    name: 'form-cash-movement',
    components: {
        'modal-cash-movement-content': ModalCashMovement,
        SupervisorUniqueKeyModal,
    },
    props: {},
    data: function() {
        return {
            comment: null,
            cash: null,
            movTypeSelected: null,
            initialInvoiceNumber: null,
            initialTicketNumber: null,
            initialCreditNoteNumber: null,
            initialTransbankNumber: null,
            finalInvoiceNumber: null,
            finalTicketNumber: null,
            finalCreditNoteNumber: null,
            itemsTypeMovement: [],
            showModal: false,
        }
    },
    computed: {
        ...mapState('CashMovementModule', {
            typeMovement: 'typeMovement',
            movement: 'movement',
            date: 'date',
            //reason: 'reason',
            cashAmount: 'cashAmount',
        }),
        ...mapState('AuthModule', {
            user: 'user',
            cash_desk_token: 'cash_desk_token',
        }),
        ...mapGetters('AuthModule', { cashDeskID: 'cashDeskID' }),
        integrationCountersAreEnabled() {
            return JSON.parse(process.env.VUE_APP_ENABLE_INTEGRATION_COUNTERS)
        },
        rules: function() {
            return {
                required: value =>
                    !!value || 'Este campo no puede estar vacío.',
                rounded: value =>
                    parseInt(value) % 10 === 0 ||
                    'Debe ingresar un valor multiplo de 10',
                requiredSelect: value =>
                    !!value || 'Debe seleccionar un valor.',
                tbklength: value => {
                    if (isNaN(value)) {
                        return 'Debe ser un número'
                    }
                    if (value.length != 6) {
                        return 'Debe tener 6 digitos'
                    }
                    return true
                },
            }
        },
        // async itemsTypeMovement() {
        //     return [
        //         {
        //             id: 1,
        //             type: 'non',
        //             flag_delete: false,
        //             created_at: '2019-02-26 15:03:31',
        //             updated_at: '2019-02-26 15:03:31',
        //         },
        //         {
        //             id: 2,
        //             type: 'corporis',
        //             flag_delete: false,
        //             created_at: '2019-02-26 15:03:31',
        //             updated_at: '2019-02-26 15:03:31',
        //         },
        //         {
        //             id: 3,
        //             type: 'est',
        //             flag_delete: false,
        //             created_at: '2019-02-26 15:03:31',
        //             updated_at: '2019-02-26 15:03:31',
        //         },
        //     ]
        // },
        cashier() {
            const fullName = hr_employee =>
                `${hr_employee.names} ${hr_employee.last_name1}`
            return fullName(this.user.hr_employee) || '-'
        },

        // showModal: {
        //     get: function() {
        //         return false
        //     },
        //     set: function(newVal) {
        //         return newVal
        //     },
        // },

        checkValues() {
            if (
                !(
                    this.typeMovement != null &&
                    this.date != null &&
                    this.cashAmount != null &&
                    this.cashAmount != '' &&
                    !isNaN(this.cashAmount)
                ) //&&
                // this.movTypeSelected != null
            ) {
                return false
            } else if (
                this.movTypeSelected === null &&
                this.typeMovement !== 'Apertura de caja'
            ) {
                return false
            }
            if (
                this.typeMovement === 'Apertura de Caja' &&
                !this.integrationCountersAreEnabled
            )
                return !!this.cashAmount
            if (
                this.typeMovement === 'Apertura de caja' &&
                this.integrationCountersAreEnabled &&
                !(
                    this.initialInvoiceNumber &&
                    this.initialTicketNumber &&
                    this.initialCreditNoteNumber &&
                    this.initialTransbankNumber &&
                    ('' + this.initialTransbankNumber).length === 6
                )
            ) {
                this.movTypeSelected = null
                return false
            }

            return true
        },
        focusOrder: function() {
            let order = [
                { val: this.cash, ref: 'amountInput' },
                { val: this.movTypeSelected, ref: 'typeSelect' },
                { val: this.initialTicketNumber, ref: 'ticketInput' },
                { val: this.finalTicketNumber, ref: 'finalTicketInput' },
                { val: this.initialInvoiceNumber, ref: 'invoiceInput' },
                { val: this.finalInvoiceNumber, ref: 'finalInvoiceInput' },
                { val: this.initialCredtNoteNumber, ref: 'creditNoteInput' },
                { val: this.finalCredtNoteNumber, ref: 'finalCreditNoteInput' },
                { val: this.initialTransbankNumber, ref: 'transbankInput' },
                { val: this.comment, ref: 'commentInput' },
            ]
            if (this.typeMovement === 'Apertura de caja') {
                order.splice(1, 1)
            } else {
                order.splice(2, 1)
            }
            return order
        },
        cashOpenIsReady() {
            return
            this.typeMovement === 'Apertura de caja' &&
                this.initialInvoiceNumber &&
                this.initialTicketNumber &&
                this.initialCreditNoteNumber &&
                this.initialTransbankNumber &&
                this.finalInvoiceNumber &&
                this.finalTicketNumber &&
                this.finalCreditNoteNumber &&
                this.initialTransbankNumber.length === 6
        },
        counters() {
            return [
                sendIntegrationTicketNumber(
                    this.initialTicketNumber,
                    this.finalTicketNumber
                ),
                sendIntegrationInvoiceTicketNumber(
                    this.initialInvoiceNumber,
                    this.finalInvoiceNumber
                ),
                sendIntegrationCreditNoteNumber(
                    this.initialCreditNoteNumber,
                    this.finalCreditNoteNumber
                ),
                // sendTransbankNumber(parseInt(this.initialTransbankNumber)),
            ]
        },
    },
    methods: {
        handleKeyDown(e) {
            if (e.keyCode === 119) {
                this.confirm()
            }
        },
        handleTbkNumber() {
            let tbk = this.initialTransbankNumber
            let len = '' + this.initialTransbankNumber
            len = len.length
            let dif = 6 - len
            if (dif && dif > 0) {
                for (let i = 0; i < dif; i++) {
                    tbk = '0' + tbk
                }
            }
            this.initialTransbankNumber = tbk
        },
        confirm() {
            if (this.cash && this.cash % 10 === 0) {
                if (this.cashOpenIsReady) {
                    this.showModal = true
                } else if (
                    this.typeMovement !== 'Apertura de caja' &&
                    this.movTypeSelected
                ) {
                    this.showModal = true
                } else {
                }
            }
        },
        resetForm() {
            this.comment = null
            this.cash = null
        },
        ...mapActions('CashMovementModule', {
            setDate: 'setDate',
            setCashAmount: 'setCashAmount',
            setComment: 'setComment',
            //setReason: 'setReason',
            saveCashMov: 'saveCashMov',
            setMovementType: 'setMovementType',
        }),

        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
        }),

        ...mapActions('CashMovementModule', {
            setDate: 'setDate',
            setCashAmount: 'setCashAmount',
            setComment: 'setComment',
            loadMovementReasons: 'loadMovementReasons',
            resetStateCashMovementModule: 'resetState',
            printReceip: 'printReceip',
        }),

        ...mapActions('UniqueKeyModule', {
            authorize: 'authorize',
            resetStateUniqueKeyModule: 'resetState',
            setUniqueKey: 'setUniqueKey',
        }),

        // FIXME: INTEGRATION ONLY
        ...mapActions('IntegrationModule', {
            setInvoiceTicketCounter: 'setInvoiceTicketCounter',
            setOfficeID: 'setOfficeID',
        }),
        // ENDFIXME

        clearFormCashMovement: function() {
            //this.reasonSelected = null
            this.comment = null
            //this.reasonsItems = null
            this.cash = null
            this.resetStateCashMovementModule()
            this.$emit('clearform')
        },
        async fetchIncomeTypes() {
            try {
                let response = await IncomeTypeModel.params({
                    get_all_results: true,
                }).get()
                console.log(response.data)
                return response.data
            } catch (e) {
                console.log(e)
            }
            return []
        },
        async fetchEgressTypes() {
            try {
                let response = await EgressTypeModel.params({
                    get_all_results: true,
                }).get()
                return response.data
            } catch (e) {
                console.log(e)
            }
        },
        sendCounters(arr = this.counters) {
            Promise.all(arr).then(console.log)
        },
        async authorizeCashMov() {
            let payload = {
                typeMessage: 'info',
                message: {
                    title: 'Confirmando',
                    body: 'Confirmando clave única',
                },
                timeout: 0,
                showProgress: true,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            }
            this.initSnackbar(payload) // Showing info + loading snackbar
            let responseAuthMov = await this.authorize()
            const fullName = ({ names, last_name1 }) => `${names} ${last_name1}`
            let supervisor = {
                name: fullName(responseAuthMov.user),
                id: responseAuthMov.user.id,
            }
            if (responseAuthMov.status == 'success') {
                if (responseAuthMov.is_authorized) {
                    // FIXME: Implementation only
                    let val = true
                    if (
                        this.typeMovement === 'Apertura de caja' &&
                        this.integrationCountersAreEnabled
                    ) {
                        const errSnack = e => {
                            if (!e.response || !e.response.data) return
                            let { message, error } = e.response.data
                            let err = `${message}: ${error}`
                            let payload = {
                                typeMessage: 'error',
                                message: {
                                    title: 'Error',
                                    body: err || 'Errorr de base de datos',
                                },
                                timeout: 6000,
                                showProgress: false,
                                showCloseBtn: true,
                                closeBtnMessage: 'cerrar',
                            }
                            this.initSnackbar(payload)
                        }
                        try {
                            let res = await sendIntegrationTicketNumber(
                                this.initialTicketNumber,
                                this.finalTicketNumber
                            )
                            res = await sendIntegrationInvoiceTicketNumber(
                                this.initialInvoiceNumber,
                                this.finalInvoiceNumber
                            )
                            res = await sendIntegrationCreditNoteNumber(
                                this.initialCreditNoteNumber,
                                this.finalCreditNoteNumber
                            )
                            console.log(
                                'cashDeskID',
                                this.cashDeskID,
                                this.initialTransbankNumber
                            )
                            res = await sendTransbankNumber(
                                parseInt(this.initialTransbankNumber),
                                this.cashDeskID
                            )
                        } catch (err) {
                            errSnack(err)
                            val = false
                        }
                    }
                    // ENDFIXME

                    if (val) {
                        return await this.saveMovement(supervisor)
                    } else {
                        let payload = {
                            typeMessage: 'error',
                            message: {
                                title: 'Error Factura Inicial',
                                body: '',
                            },
                            timeout: 6000,
                            showProgress: false,
                            showCloseBtn: true,
                            closeBtnMessage: 'cerrar',
                        }
                        this.initSnackbar(payload)
                    }
                } else {
                    let payload = {
                        typeMessage: 'error',
                        message: {
                            title: 'Sin permiso',
                            body:
                                'El código ingresado no está autorizado para realizar el movimiento',
                        },
                        timeout: 6000,
                        showProgress: false,
                        showCloseBtn: true,
                        closeBtnMessage: 'cerrar',
                    }
                    this.initSnackbar(payload)
                }
            } else if (responseAuthMov.status == 'error') {
                let payload = {
                    typeMessage: 'warning',
                    message: {
                        title: 'Error',
                        body: responseAuthMov.message,
                    },
                    timeout: 0,
                    showProgress: false,
                    showCloseBtn: true,
                    closeBtnMessage: 'cerrar',
                }
                this.initSnackbar(payload)
            }
        },

        async saveMovement(supervisor = null) {
            let responseSaveMov = await this.saveCashMov()
            if ((responseSaveMov.status = 'success')) {
                if (
                    responseSaveMov.http_status_code === 200 ||
                    responseSaveMov.http_status_code === 201
                ) {
                    let payload = {
                        typeMessage: 'info',
                        message: {
                            title: 'AUTORIZADO',
                            body: 'Imprimiendo comprobante',
                        },
                        timeout: 6000,
                        showProgress: true,
                        showCloseBtn: true,
                        closeBtnMessage: 'cerrar',
                    }
                    this.initSnackbar(payload)
                    this.resetStateUniqueKeyModule()

                    let id
                    if (this.movement === 'apertura') {
                        id = responseSaveMov.pos_daily_cash.id
                    } else {
                        id = responseSaveMov.pos_cash_movement.id
                    }
                    //Add Supervisor user data
                    let printed = await this.printReceip({
                        idMovCaja: id,
                        supervisor,
                    })

                    payload = {
                        typeMessage: 'success',
                        message: {
                            title: 'Éxito',
                            body: `Comprobante de ${this.movement} impreso.`,
                        },
                        timeout: 6000,
                        showProgress: false,
                        showCloseBtn: true,
                        closeBtnMessage: 'cerrar',
                    }
                    this.initSnackbar(payload)

                    this.clearFormCashMovement()
                } else {
                    let payload = {
                        typeMessage: 'error',
                        message: {
                            title: 'ERROR',
                            body: responseSaveMov.error,
                        },
                        timeout: 6000,
                        showProgress: false,
                        showCloseBtn: true,
                        closeBtnMessage: 'cerrar',
                    }
                    this.setUniqueKey('')
                    this.initSnackbar(payload)
                }
            } else {
                let payload = {
                    typeMessage: 'warning',
                    message: {
                        title: 'ERROR',
                        body: responseSaveMov.error,
                    },
                    timeout: 6000,
                    showProgress: false,
                    showCloseBtn: true,
                    closeBtnMessage: 'cerrar',
                }
                this.setUniqueKey('')
                this.initSnackbar(payload)
            }
            this.showModal = false
        },
        fetchTypes: async function() {
            if (this.typeMovement === 'Ingreso de caja') {
                this.itemsTypeMovement = await this.fetchIncomeTypes()
                return true
            }
            if (this.typeMovement === 'Egreso de caja') {
                this.itemsTypeMovement = await this.fetchEgressTypes()
                return true
            }
            this.itemsTypeMovement = []
            return false
        },
        fetchCounters: async function() {
            console.log(2)
            let r = await getAllCounters(this.cashDeskID)
            Object.assign(this.$data, r)
        },
        async initCounters() {
            console.log(1)
            await this.fetchCounters()
            this.handleTbkNumber()
        },
    },
    watch: {
        typeMovement: {
            handler: async function(val) {
                console.log(0, val)
                await this.fetchTypes()
                if (val === 'Apertura de caja') await this.initCounters()
            },
            immediate: true,
        },
    },
    mixins: [CurrencyUtils, DateUtils, JSUtils],
    // filters: {},
    created: async function() {
        this.fetchTypes()
    },
    mounted: async function() {
        this.mixFocusByRef('amountInput')
        await this.loadMovementReasons() // TODO: Quitarlo de aqui y cargarlo cuando se haga login ó apertura de caja
        this.setDate(this.getCurrentDate)
        this.$refs.cashMovArea.addEventListener('keydown', e =>
            this.handleKeyDown(e)
        )
    },
}
</script>

<style lang="scss"></style>
